import { useEffect, useState } from "react";
import { getProfessionsList, getCategoriesList, createProfession } from "../../../services/adminService";
import { toast } from "react-toastify";

const AdminProfessions = () => {
  const [professions, setProfessions] = useState([]);
  const [categories, setCategories] = useState([]);
  const [newProfessionName, setNewProfessionName] = useState("");
  const [newProfessionType, setNewProfessionType] = useState("freelancer");
  const [newProfessionCategoryId, setNewProfessionCategoryId] = useState("");
  const [creatingProfession, setCreatingProfession] = useState(false);
  const [loading, setLoading] = useState(true);

  // Fetch professions and categories on mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [profData, catData] = await Promise.all([
          getProfessionsList(),
          getCategoriesList(),
        ]);
        setProfessions(profData);
        setCategories(catData);
      } catch (error) {
        console.error("Failed to fetch professions or categories:", error);
        toast.error("Failed to load data.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleCreateProfession = async () => {
    if (!newProfessionName.trim() || !newProfessionCategoryId) return;

    try {
      setCreatingProfession(true);
      const created = await createProfession({
        name: newProfessionName.trim(),
        type: newProfessionType,
        category_id: newProfessionCategoryId,
      });
      setProfessions((prev) => [created, ...prev]);
      setNewProfessionName("");
      setNewProfessionType("freelancer");
      setNewProfessionCategoryId("");
      toast.success(`Profession "${created.name}" created`);
    } catch (error) {
      console.error("Failed to create profession:", error);
      toast.error("Failed to create profession or it already exists.");
    } finally {
      setCreatingProfession(false);
    }
  };

  if (loading) return <p>Loading professions...</p>;

  return (
    <div className="admin-professions">
      <h2>Service Professions</h2>

      <div className="profession-create-row">
        <input
          type="text"
          placeholder="New profession name"
          value={newProfessionName}
          onChange={(e) => setNewProfessionName(e.target.value)}
        />

        <select
          value={newProfessionType}
          onChange={(e) => setNewProfessionType(e.target.value)}
        >
          <option value="freelancer">Freelancer</option>
          <option value="business">Business</option>
        </select>

        <select
          value={newProfessionCategoryId}
          onChange={(e) => setNewProfessionCategoryId(e.target.value)}
        >
          <option value="">Select Category</option>
          {categories.map((cat) => (
            <option key={cat.id} value={cat.id}>
              {cat.name}
            </option>
          ))}
        </select>

        <button onClick={handleCreateProfession} disabled={creatingProfession}>
          {creatingProfession ? "Adding..." : "Add Profession"}
        </button>
      </div>

      {professions.length === 0 ? (
        <p>No professions found.</p>
      ) : (
        <ul>
          {professions.map((prof) => (
            <li key={prof.id} className="list-row">
              <span className="row-main">
                {prof.name} ({prof.type}) — {prof.category.name}
              </span>
              <span className="row-date">
                {new Date(prof.created_at).toLocaleString([], {
                  year: "numeric",
                  month: "short",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AdminProfessions;
